module.exports = __webpack_public_path__ + "img/gamesHeader.e22a8c90.svg";